/**
 * @generated SignedSource<<0f503e0b23f9c52d6da949191b9f53d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "participativeModuleSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsSubmissionAuthorized",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "IntlMessage",
  "kind": "LinkedField",
  "name": "customIntlMessages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    (v7/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsDisplayAuthorized",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opacity",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contrastColor",
        "storageKey": null
      },
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetX",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetY",
        "storageKey": null
      },
      (v15/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v17/*: any*/),
            "type": "Image",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v17/*: any*/),
            "type": "StaticImage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v3/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementThemeStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markersMaxClusterRadius",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "visualization",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ParticipativeModule",
          "kind": "LinkedField",
          "name": "participativeModule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Theme",
              "kind": "LinkedField",
              "name": "themes",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v19/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsZIndexOffset",
          "storageKey": null
        }
      ],
      "type": "ContributionsMap",
      "abstractKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowSendingNotificationOnContentUpdate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ResourceTreeTaxonomy",
  "kind": "LinkedField",
  "name": "taxonomies",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Taxonomy",
      "kind": "LinkedField",
      "name": "taxonomy",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleImageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alreadySubscribed",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribersCount",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domId",
  "storageKey": null
},
v29 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPageSectionBase"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsible",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsedHeight",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsRatio",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnsOrder",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullHeight",
  "storageKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v11/*: any*/)
  ],
  "type": "PageSectionWithHeadingData",
  "abstractKey": "__isPageSectionWithHeadingData"
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    (v36/*: any*/)
  ],
  "type": "PageSectionSidebarText",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    (v11/*: any*/),
    (v16/*: any*/)
  ],
  "type": "PageSectionSidebarLinkBlock",
  "abstractKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removeRequestTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UsersGroup",
      "kind": "LinkedField",
      "name": "usersGroup",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyGroupMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alreadyRequested",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersGroupAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendJoinGroupRequest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionSidebarUsersGroupRequestLinkBlock",
  "abstractKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hlsUrl",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaTitle",
  "storageKey": null
},
v45 = [
  (v16/*: any*/),
  (v3/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "transcription",
  "plural": false,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "audio",
  "plural": false,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "altText",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x15Url",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x2Url",
  "storageKey": null
},
v51 = [
  (v16/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v52 = [
  (v48/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "large",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ratio",
        "storageKey": null
      },
      (v16/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "medium",
    "plural": false,
    "selections": (v51/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "small",
    "plural": false,
    "selections": (v51/*: any*/),
    "storageKey": null
  },
  (v3/*: any*/)
],
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hlsLibUrl",
      "storageKey": null
    },
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": (v52/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WithBunnyStreamVideo",
  "abstractKey": "__isWithBunnyStreamVideo"
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoplay",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slidesInterval",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Slide",
  "kind": "LinkedField",
  "name": "slides",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableOverlay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayContentTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayButtonTextColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overlayOpacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponsiveImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v52/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "LibraryFile",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v10/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileExtension",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "ResourceTarget",
  "kind": "LinkedField",
  "name": "resourceTargets",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v10/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "analyticsData",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isAnalyticsDatumInterface"
        },
        (v59/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionAnalyticsDataList",
  "abstractKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zIndexOffset",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMin",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMax",
  "storageKey": null
},
v67 = [
  (v63/*: any*/),
  (v64/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPointStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v65/*: any*/),
        (v66/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v67/*: any*/),
              "type": "MapElementPointStyle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v67/*: any*/),
              "type": "MapElementCompoundFeatureStyle",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visualization",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v61/*: any*/)
              ],
              "type": "EventVisualization",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v6/*: any*/),
    (v68/*: any*/)
  ],
  "type": "PageSectionSidebarEventsList",
  "abstractKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayQuestionsLabel",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayParticipationData",
  "storageKey": null
},
v72 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": (v72/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "participativeModuleIds",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrent",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModule",
  "kind": "LinkedField",
  "name": "participativeModules",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v11/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Step",
      "kind": "LinkedField",
      "name": "currentStep",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v75/*: any*/),
        (v76/*: any*/),
        (v77/*: any*/),
        (v78/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDisplayAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDownAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsCountDisplayAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesUpCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesDownCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributionsCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarResource",
  "kind": "LinkedField",
  "name": "resources",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v12/*: any*/),
    (v61/*: any*/),
    (v80/*: any*/),
    (v6/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventMode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Sidebar",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSections",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "PageSectionBaseConnection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageSectionBaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v28/*: any*/),
                (v35/*: any*/),
                (v29/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v41/*: any*/),
                    (v16/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    (v46/*: any*/),
                    (v47/*: any*/),
                    (v53/*: any*/)
                  ],
                  "type": "PageSectionEmbed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v54/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionSidebarBanner",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v57/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionFilesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v58/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionPagesList",
                  "abstractKey": null
                },
                (v60/*: any*/),
                (v69/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v40/*: any*/),
                    (v11/*: any*/),
                    (v70/*: any*/),
                    (v71/*: any*/),
                    (v73/*: any*/),
                    (v74/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModuleResults",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v79/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModulesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v40/*: any*/),
                    (v81/*: any*/)
                  ],
                  "type": "PageSectionCalendar",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v82/*: any*/)
          ],
          "storageKey": null
        },
        (v83/*: any*/)
      ],
      "storageKey": "sections(first:2147483647)"
    },
    {
      "alias": null,
      "args": (v27/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Sidebar_sections",
      "kind": "LinkedHandle",
      "name": "sections"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomDefault",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomMin",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomMax",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomDefault",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomMin",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileZoomMax",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "centerLatitude",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "centerLongitude",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tileLayerUrl",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapDataAttribution",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "MapZoomLevelConfiguration",
  "kind": "LinkedField",
  "name": "zoomLevels",
  "plural": true,
  "selections": [
    (v65/*: any*/),
    (v66/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasElements",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vectorTileUrl",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPoint",
  "kind": "LinkedField",
  "name": "clusterizedPoints",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInformationWindow",
      "storageKey": null
    },
    (v98/*: any*/),
    (v99/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mapElementGeometryId",
      "storageKey": null
    },
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementTooltip",
      "kind": "LinkedField",
      "name": "tooltip",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v102 = [
  (v3/*: any*/)
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "MapTaxonomy",
  "kind": "LinkedField",
  "name": "children",
  "plural": true,
  "selections": (v102/*: any*/),
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "MapFilterList",
  "kind": "LinkedField",
  "name": "filterLists",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MapTaxonomy",
              "kind": "LinkedField",
              "name": "mapTaxonomies",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v103/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "MapFilterTaxonomy",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "mapElements",
              "plural": true,
              "selections": (v72/*: any*/),
              "storageKey": null
            }
          ],
          "type": "MapFilterElement",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v106 = [
  (v12/*: any*/),
  (v15/*: any*/),
  (v105/*: any*/),
  (v13/*: any*/),
  (v62/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MapElementZoomLevelStyle",
    "kind": "LinkedField",
    "name": "zoomLevels",
    "plural": true,
    "selections": [
      (v65/*: any*/),
      (v66/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "style",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              (v15/*: any*/),
              (v105/*: any*/),
              (v13/*: any*/),
              (v62/*: any*/)
            ],
            "type": "MapElementPathStyle",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  (v3/*: any*/)
],
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPathStyle",
  "kind": "LinkedField",
  "name": "borderStyle",
  "plural": false,
  "selections": (v106/*: any*/),
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementShapeStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v107/*: any*/),
    (v64/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v65/*: any*/),
        (v66/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v107/*: any*/),
                (v64/*: any*/)
              ],
              "type": "MapElementShapeStyle",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "MapElementConnection",
  "kind": "LinkedField",
  "name": "elements",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MapTaxonomy",
              "kind": "LinkedField",
              "name": "mapTaxonomies",
              "plural": true,
              "selections": (v102/*: any*/),
              "storageKey": null
            },
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isMapElement"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "geometriesType",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapElementCompoundFeatureStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": [
                    (v62/*: any*/),
                    (v63/*: any*/),
                    (v107/*: any*/),
                    (v64/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MapElementShadowStyle",
                      "kind": "LinkedField",
                      "name": "shadowStyle",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "offsetX",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "offsetY",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "blur",
                          "storageKey": null
                        },
                        (v12/*: any*/),
                        (v15/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MapElementZoomLevelStyle",
                      "kind": "LinkedField",
                      "name": "zoomLevels",
                      "plural": true,
                      "selections": [
                        (v65/*: any*/),
                        (v66/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "style",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v63/*: any*/)
                              ],
                              "type": "MapElementCompoundFeatureStyle",
                              "abstractKey": null
                            },
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "MapElementCompoundFeature",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MapElementPathStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": (v106/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "MapElementPath",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v68/*: any*/)
              ],
              "type": "MapElementPoint",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v108/*: any*/)
              ],
              "type": "MapElementShape",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v82/*: any*/)
      ],
      "storageKey": null
    },
    (v83/*: any*/)
  ],
  "storageKey": "elements(first:2147483647)"
},
v110 = {
  "alias": null,
  "args": (v27/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "MapElements_elements",
  "kind": "LinkedHandle",
  "name": "elements"
},
v111 = [
  (v6/*: any*/),
  (v11/*: any*/),
  (v40/*: any*/)
],
v112 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "PageSectionBaseConnection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageSectionBaseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v28/*: any*/),
                (v29/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v30/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/)
                  ],
                  "type": "PageSectionText",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v54/*: any*/),
                    (v55/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    (v56/*: any*/)
                  ],
                  "type": "PageSectionBanner",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v40/*: any*/),
                    (v11/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    (v79/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModulesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayMode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hideIfEmpty",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Event",
                      "kind": "LinkedField",
                      "name": "events",
                      "plural": true,
                      "selections": [
                        (v3/*: any*/),
                        (v5/*: any*/),
                        (v6/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "visualization",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v61/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "placeName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "address",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "zip",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "city",
                                  "storageKey": null
                                }
                              ],
                              "type": "EventVisualization",
                              "abstractKey": null
                            },
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PageSectionEventsList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    (v81/*: any*/)
                  ],
                  "type": "PageSectionCalendar",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actorsPerRow",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentAlignment",
                      "storageKey": null
                    },
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Actor",
                      "kind": "LinkedField",
                      "name": "actors",
                      "plural": true,
                      "selections": [
                        (v3/*: any*/),
                        (v10/*: any*/),
                        (v40/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResponsiveImage",
                          "kind": "LinkedField",
                          "name": "logo",
                          "plural": false,
                          "selections": (v52/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PageSectionActorsList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v58/*: any*/)
                  ],
                  "type": "PageSectionPagesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    (v57/*: any*/),
                    {
                      "kind": "TypeDiscriminator",
                      "abstractKey": "__isPageSectionWithHeadingData"
                    }
                  ],
                  "type": "PageSectionFilesList",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "blocksDisplayMode",
                      "storageKey": null
                    },
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FeaturedContentBlock",
                      "kind": "LinkedField",
                      "name": "featuredContentBlocks",
                      "plural": true,
                      "selections": [
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v6/*: any*/),
                        (v40/*: any*/),
                        (v16/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Image",
                          "kind": "LinkedField",
                          "name": "image",
                          "plural": false,
                          "selections": [
                            (v16/*: any*/),
                            (v48/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ResponsiveImage",
                          "kind": "LinkedField",
                          "name": "originalImage",
                          "plural": false,
                          "selections": [
                            (v48/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Image",
                              "kind": "LinkedField",
                              "name": "large",
                              "plural": false,
                              "selections": (v17/*: any*/),
                              "storageKey": null
                            },
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v84/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "blocksPerRow",
                      "storageKey": null
                    },
                    (v54/*: any*/),
                    (v55/*: any*/)
                  ],
                  "type": "PageSectionFeaturedContent",
                  "abstractKey": null
                },
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v42/*: any*/),
                    (v41/*: any*/),
                    (v16/*: any*/),
                    (v43/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isEmpty",
                      "storageKey": null
                    },
                    (v44/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v46/*: any*/),
                    (v47/*: any*/),
                    (v53/*: any*/)
                  ],
                  "type": "PageSectionEmbed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    (v70/*: any*/),
                    (v71/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v84/*: any*/),
                    (v73/*: any*/),
                    (v74/*: any*/)
                  ],
                  "type": "PageSectionParticipativeModuleResults",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mapHeight",
                      "storageKey": null
                    },
                    (v85/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "map",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ParticipativeModule",
                              "kind": "LinkedField",
                              "name": "participativeModule",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ParticipativeModuleAuthorizations",
                                  "kind": "LinkedField",
                                  "name": "authorizations",
                                  "plural": false,
                                  "selections": [
                                    (v9/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v5/*: any*/),
                                (v21/*: any*/),
                                (v3/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "VisualizationMap",
                          "abstractKey": null
                        },
                        {
                          "kind": "TypeDiscriminator",
                          "abstractKey": "__isMap"
                        },
                        (v5/*: any*/),
                        (v3/*: any*/),
                        (v85/*: any*/),
                        (v86/*: any*/),
                        (v87/*: any*/),
                        (v88/*: any*/),
                        (v89/*: any*/),
                        (v90/*: any*/),
                        (v91/*: any*/),
                        (v92/*: any*/),
                        (v93/*: any*/),
                        (v94/*: any*/),
                        (v95/*: any*/),
                        (v96/*: any*/),
                        (v97/*: any*/),
                        (v20/*: any*/),
                        (v100/*: any*/),
                        (v104/*: any*/),
                        (v109/*: any*/),
                        (v110/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PageSectionMap",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SearchConfiguration",
                      "kind": "LinkedField",
                      "name": "searchConfiguration",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayOptionsByDefault",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PageSectionSearchBox",
                  "abstractKey": null
                },
                (v60/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v35/*: any*/),
                    (v54/*: any*/),
                    (v55/*: any*/),
                    (v56/*: any*/),
                    (v36/*: any*/)
                  ],
                  "type": "PageSectionSidebarBanner",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v59/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayLabel",
                      "storageKey": null
                    },
                    (v30/*: any*/)
                  ],
                  "type": "PageSectionMapElementFeatureAttribute",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/),
                    (v11/*: any*/),
                    (v40/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultAcceptsCookiesValue",
                      "storageKey": null
                    }
                  ],
                  "type": "PageSectionCookiesConsentsConfiguration",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v111/*: any*/),
                  "type": "PageSectionSitemap",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v111/*: any*/),
                  "type": "PageSectionInformationSearch",
                  "abstractKey": null
                },
                (v69/*: any*/)
              ],
              "storageKey": null
            },
            (v82/*: any*/)
          ],
          "storageKey": null
        },
        (v83/*: any*/)
      ],
      "storageKey": "sections(first:2147483647)"
    },
    {
      "alias": null,
      "args": (v27/*: any*/),
      "filters": null,
      "handle": "connection",
      "key": "Page_sections",
      "kind": "LinkedHandle",
      "name": "sections"
    }
  ],
  "type": "ResourceWithSections",
  "abstractKey": "__isResourceWithSections"
},
v113 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipativeModuleAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v24/*: any*/),
        (v3/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v23/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v22/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "type": "ResourceTreeLeaf",
          "abstractKey": "__isResourceTreeLeaf"
        }
      ],
      "type": "ResourceWithSubscription",
      "abstractKey": "__isResourceWithSubscription"
    }
  ],
  "type": "ResourceTreeLeaf",
  "abstractKey": "__isResourceTreeLeaf"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipativeModuleRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ParticipativeModule_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ParticipativeModuleRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isParticipativeModuleInterface"
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visualizationDisplayAuthorized",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayParticipativeModuleStepsAfterSections",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFullScreen",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isParticipativeModuleVisualization"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "participativeModule",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParticipativeModuleAuthorizations",
                            "kind": "LinkedField",
                            "name": "authorizations",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryColor",
                                "storageKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v21/*: any*/)
                        ],
                        "type": "ParticipativeModule",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v24/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isResourceWithSubscription"
                          }
                        ],
                        "type": "ResourceTreeLeaf",
                        "abstractKey": "__isResourceTreeLeaf"
                      },
                      (v112/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contributionsPerPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableListViewOnFirstPage",
                        "storageKey": null
                      }
                    ],
                    "type": "ContributionsDataviz",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipativeModule",
                        "kind": "LinkedField",
                        "name": "participativeModule",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "visualization",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v113/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementThemeStyle",
                        "kind": "LinkedField",
                        "name": "newContributionMarkerStyle",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapDroppableZone",
                        "kind": "LinkedField",
                        "name": "contributionZone",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasCoordinates",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": (v27/*: any*/),
                            "concreteType": "MapElementMultiPolygonConnection",
                            "kind": "LinkedField",
                            "name": "multiPolygons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapElementMultiPolygonEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapElementMultiPolygon",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "coordinates",
                                        "storageKey": null
                                      },
                                      (v108/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v82/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v83/*: any*/)
                            ],
                            "storageKey": "multiPolygons(first:2147483647)"
                          },
                          {
                            "alias": null,
                            "args": (v27/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "MapDroppableZone_multiPolygons",
                            "kind": "LinkedHandle",
                            "name": "multiPolygons"
                          },
                          (v108/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v88/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v95/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          (v20/*: any*/),
                          (v100/*: any*/),
                          (v104/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/)
                        ],
                        "type": "Map",
                        "abstractKey": "__isMap"
                      }
                    ],
                    "type": "ContributionsMap",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapFilterList",
                        "kind": "LinkedField",
                        "name": "filterLists",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "filters",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isMapFilterBase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowSelectingMultipleTaxonomies",
                                    "storageKey": null
                                  },
                                  (v101/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapTaxonomy",
                                    "kind": "LinkedField",
                                    "name": "mapTaxonomies",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasChildren",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapTaxonomy",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v10/*: any*/),
                                          (v114/*: any*/),
                                          (v103/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v10/*: any*/),
                                      (v114/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MapFilterTaxonomy",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v101/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowSelectingMultipleElements",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "mapElements",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MapFilterElement",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapFilterUserField",
                                    "kind": "LinkedField",
                                    "name": "userFields",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapFilterUserFieldOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v10/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MapFilterUser",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Map",
                    "abstractKey": "__isMap"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "waypointsCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CityWalkWaypoint",
                        "kind": "LinkedField",
                        "name": "waypoints",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "element",
                            "plural": false,
                            "selections": (v72/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CityWalkContribution",
                        "kind": "LinkedField",
                        "name": "activeContribution",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplete",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v88/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v95/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          (v20/*: any*/),
                          (v100/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/)
                        ],
                        "type": "Map",
                        "abstractKey": "__isMap"
                      }
                    ],
                    "type": "CityWalk",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayParticipativeModuleSteps",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Step",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v77/*: any*/),
                      (v10/*: any*/),
                      (v78/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Steppable",
                "abstractKey": "__isSteppable"
              },
              (v112/*: any*/),
              (v115/*: any*/)
            ],
            "type": "ParticipativeModule",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v113/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v61/*: any*/),
                      (v80/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alreadySubmitted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remainingSeats",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maximumSeats",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAuthorizations",
                        "kind": "LinkedField",
                        "name": "authorizations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayMaximumSeats",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayRemainingSeats",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allowAddingEventsToCalendar",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v98/*: any*/),
                      (v99/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventMarker",
                        "kind": "LinkedField",
                        "name": "marker",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "targetUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tooltipContent",
                                "storageKey": null
                              },
                              (v98/*: any*/),
                              (v99/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MapMarkerStyle",
                                "kind": "LinkedField",
                                "name": "markerStyle",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "backgroundColor",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MapMarker",
                            "abstractKey": "__isMapMarker"
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VisualizationMap",
                        "kind": "LinkedField",
                        "name": "map",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              (v90/*: any*/),
                              (v91/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v94/*: any*/),
                              (v95/*: any*/),
                              (v96/*: any*/),
                              (v97/*: any*/),
                              (v20/*: any*/),
                              (v100/*: any*/),
                              (v104/*: any*/),
                              (v109/*: any*/),
                              (v110/*: any*/)
                            ],
                            "type": "Map",
                            "abstractKey": "__isMap"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullAddress",
                        "storageKey": null
                      }
                    ],
                    "type": "EventVisualization",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v115/*: any*/),
              (v112/*: any*/)
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "050010fa854197f284811c37a63ac7ee",
    "id": null,
    "metadata": {},
    "name": "ParticipativeModuleRouteQuery",
    "operationKind": "query",
    "text": "query ParticipativeModuleRouteQuery(\n  $participativeModuleSlug: ID!\n) {\n  participativeModule(participativeModuleSlug: $participativeModuleSlug) {\n    __typename\n    ...ParticipativeModule_participativeModule\n    id\n  }\n}\n\nfragment AnalyticsDatumCardRow_analyticsDatum on AnalyticsDatumInterface {\n  __isAnalyticsDatumInterface: __typename\n  label\n  count\n}\n\nfragment AudioPlayer_audio on Attachment {\n  url\n}\n\nfragment Breadcrumbs_page on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  ancestors {\n    __typename\n    id\n    title\n    resourcePath\n  }\n}\n\nfragment CalendarDayEventsPanel_events on CalendarResource {\n  id\n  ...CalendarResourceItem_event\n}\n\nfragment CalendarResourceItem_event on CalendarResource {\n  title\n  url\n  color\n  startsAt\n  endsAt\n  eventMode\n}\n\nfragment Calendar_section on PageSectionCalendar {\n  resources {\n    id\n    color\n    startsAt\n    endsAt\n    ...CalendarDayEventsPanel_events\n  }\n}\n\nfragment CardStep_step on Step {\n  name\n  startDate\n  endDate\n  isCurrent\n  position\n}\n\nfragment CityWalkCompleteDialog_cityWalk on CityWalk {\n  activeContribution {\n    id\n  }\n  customIntlMessages {\n    identifier\n    message\n    id\n  }\n}\n\nfragment CityWalkComplete_cityWalk on CityWalk {\n  id\n  slug\n}\n\nfragment CityWalkLayout_cityWalk on CityWalk {\n  slug\n  waypointsCount\n  waypoints {\n    id\n    element {\n      __typename\n      id\n    }\n  }\n  activeContribution {\n    isComplete\n    id\n  }\n  ...CityWalkCompleteDialog_cityWalk\n  ...CityWalkComplete_cityWalk\n  ...MapWithSidebarLayout_map\n}\n\nfragment CityWalk_cityWalk on ParticipativeModuleVisualization {\n  __isParticipativeModuleVisualization: __typename\n  ... on CityWalk {\n    ...MapContextProvider_map\n    ...CityWalkLayout_cityWalk\n  }\n}\n\nfragment ContainerWithSidebar_sidebar on Sidebar {\n  hasSections\n  ...Sidebar_sidebar\n}\n\nfragment ContributeButton_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    customIntlMessages {\n      identifier\n      message\n      id\n    }\n    id\n  }\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n}\n\nfragment ContributionsDataviz_visualization on ParticipativeModuleVisualization {\n  __isParticipativeModuleVisualization: __typename\n  ... on ContributionsDataviz {\n    contributionsPerPage\n    enableListViewOnFirstPage\n  }\n}\n\nfragment ContributionsMapContributionMarker_map on ContributionsMap {\n  contributionsZIndexOffset\n  participativeModule {\n    slug\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsManager_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsMapContributionsMarkersManager_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsMap {\n      ...ContributionsMapContributionsMarkers_map\n    }\n    id\n  }\n}\n\nfragment ContributionsMapContributionsMarkers_map on ContributionsMap {\n  ...ContributionsMapThemeContributionsMarkers_map\n}\n\nfragment ContributionsMapLayout_map on ContributionsMap {\n  participativeModule {\n    slug\n    authorizations {\n      contributionsSubmissionAuthorized\n    }\n    id\n  }\n  contributionZone {\n    hasCoordinates\n    ...MapDroppableZone_droppableZone\n    ...MapDroppableZoneWithoutLimit_droppableZone\n    id\n  }\n  ...MapWithSidebarLayout_map\n}\n\nfragment ContributionsMapNewContributionBox_map on ContributionsMap {\n  participativeModule {\n    slug\n    visualization {\n      __typename\n      customIntlMessages {\n        identifier\n        message\n        id\n      }\n      id\n    }\n    id\n  }\n  newContributionMarkerStyle {\n    ... on MapElementImageStyle {\n      __isMapElementImageStyle: __typename\n      iconClass\n      color\n      contrastColor\n      width\n      height\n      anchor\n      anchorOffsetX\n      anchorOffsetY\n      opacity\n      image {\n        __typename\n        ... on Image {\n          url\n        }\n        ... on StaticImage {\n          url\n        }\n      }\n    }\n    ...ContributionsMapNewContributionDraggableElement_style\n    id\n  }\n}\n\nfragment ContributionsMapNewContributionDraggableElement_style on MapElementImageStyle {\n  __isMapElementImageStyle: __typename\n  iconClass\n  color\n  contrastColor\n  width\n  height\n  anchor\n  anchorOffsetX\n  anchorOffsetY\n  opacity\n  image {\n    __typename\n    ... on Image {\n      url\n    }\n    ... on StaticImage {\n      url\n    }\n  }\n}\n\nfragment ContributionsMapThemeBox_theme on Theme {\n  id\n  name\n  primaryColor\n  style {\n    ... on MapElementImageStyle {\n      __isMapElementImageStyle: __typename\n      iconClass\n      color\n      contrastColor\n      width\n      height\n      anchor\n      anchorOffsetX\n      anchorOffsetY\n      opacity\n      image {\n        __typename\n        ... on Image {\n          url\n        }\n        ... on StaticImage {\n          url\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsMapThemeContributionsMarkers_map on ContributionsMap {\n  markersMaxClusterRadius\n  participativeModule {\n    themes {\n      id\n      style {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  ...ContributionsMapContributionMarker_map\n}\n\nfragment ContributionsMap_map on ParticipativeModuleVisualization {\n  __isParticipativeModuleVisualization: __typename\n  id\n  ... on ContributionsMap {\n    ...MapContextProvider_map\n    ...ContributionsMapNewContributionBox_map\n    ...ContributionsMapLayout_map\n  }\n  participativeModule {\n    __typename\n    ... on ParticipativeModule {\n      authorizations {\n        contributionsSubmissionAuthorized\n        contributionsDisplayAuthorized\n      }\n      themes {\n        id\n        ...ContributionsMapThemeBox_theme\n      }\n    }\n    ...ContributionsMapContributionsManager_participativeModule\n    ...ContributionsMapContributionsMarkersManager_participativeModule\n    ...MapSidebar_map\n    ...MapSidebar_sidebar\n    id\n  }\n  ...MapFilters_map\n}\n\nfragment EventCalendarDropdownButton_participativeModule on Event {\n  title\n  slug\n  visualization {\n    __typename\n    ... on EventVisualization {\n      fullAddress\n      startsAt\n      endsAt\n      authorizations {\n        allowAddingEventsToCalendar\n      }\n    }\n    id\n  }\n}\n\nfragment EventCard_participativeModule on Event {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n      placeName\n      address\n      zip\n      city\n    }\n    id\n  }\n}\n\nfragment EventDetails_participativeModule on Event {\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n      endsAt\n      alreadySubmitted\n      remainingSeats\n      maximumSeats\n      authorizations {\n        displayMaximumSeats\n        displayRemainingSeats\n      }\n      ...EventMap_event\n    }\n    id\n  }\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n  ...TitleBarWithAction_resource\n  ...SubscribeToEventButton_participativeModule\n  ...EventCalendarDropdownButton_participativeModule\n  ...PageSections_page\n}\n\nfragment EventMap_event on EventVisualization {\n  latitude\n  longitude\n  marker {\n    ...InformativeMarker_marker\n    id\n  }\n  map {\n    ...MapBase_map\n    id\n  }\n}\n\nfragment Event_participativeModule on Event {\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n  ...TitleBarWithAction_resource\n  ...SubscribeToEventButton_participativeModule\n  ...EventDetails_participativeModule\n}\n\nfragment FeaturedContentBlockImage_block on FeaturedContentBlock {\n  url\n  originalImage {\n    altText\n    large {\n      url\n    }\n    id\n  }\n}\n\nfragment FeaturedContentBlockText_block on FeaturedContentBlock {\n  title\n  description\n  url\n  image {\n    url\n    altText\n  }\n}\n\nfragment FeaturedContentBlock_block on FeaturedContentBlock {\n  title\n  ...FeaturedContentBlockText_block\n  ...FeaturedContentBlockImage_block\n}\n\nfragment FeaturedContentCarousel_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  autoplay\n  slidesInterval\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment FeaturedContentGrid_featuredContent on PageSectionFeaturedContent {\n  blocksPerRow\n  featuredContentBlocks {\n    id\n    ...FeaturedContentBlock_block\n  }\n}\n\nfragment InformativeMarker_marker on MapMarker {\n  __isMapMarker: __typename\n  targetUrl\n  tooltipContent\n  latitude\n  longitude\n  markerStyle {\n    backgroundColor\n    id\n  }\n}\n\nfragment LibraryFile_file on LibraryFile {\n  name\n  url\n  size\n  fileExtension\n}\n\nfragment LinkSlide_slide on Slide {\n  url\n}\n\nfragment MapBase_map on Map {\n  __isMap: __typename\n  id\n  zoomDefault\n  zoomMin\n  zoomMax\n  mobileZoomDefault\n  mobileZoomMin\n  mobileZoomMax\n  centerLatitude\n  centerLongitude\n  tileLayerUrl\n  mapDataAttribution\n  zoomLevels {\n    zoomLevelMin\n    zoomLevelMax\n    tileLayerUrl\n    mapDataAttribution\n    id\n  }\n  ...MapElementsVectorGrid_map\n}\n\nfragment MapClusterizedPointMarker_point on MapElementPoint {\n  id\n  hasInformationWindow\n  latitude\n  longitude\n  mapElementGeometryId\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  tooltip {\n    ...MapElementTooltip_tooltip\n    id\n  }\n}\n\nfragment MapClusterizedPointMarkers_map on Map {\n  __isMap: __typename\n  markersMaxClusterRadius\n  clusterizedPoints {\n    id\n    ...MapClusterizedPointMarker_point\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapContextProvider_map on Map {\n  __isMap: __typename\n  __typename\n  slug\n}\n\nfragment MapDroppableZoneWithoutLimit_droppableZone on MapDroppableZone {\n  style {\n    zIndexOffset\n    borderStyle {\n      color\n      opacity\n      style\n      width\n      zIndexOffset\n      zoomLevels {\n        zoomLevelMin\n        zoomLevelMax\n        style {\n          __typename\n          ... on MapElementPathStyle {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementShapeStyle {\n          borderStyle {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MapDroppableZone_droppableZone on MapDroppableZone {\n  id\n  hasCoordinates\n  multiPolygons(first: 2147483647) {\n    edges {\n      node {\n        id\n        coordinates\n        style {\n          zIndexOffset\n          borderStyle {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          zoomLevels {\n            zoomLevelMin\n            zoomLevelMax\n            style {\n              __typename\n              ... on MapElementShapeStyle {\n                borderStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                  zoomLevels {\n                    zoomLevelMin\n                    zoomLevelMax\n                    style {\n                      __typename\n                      ... on MapElementPathStyle {\n                        color\n                        opacity\n                        style\n                        width\n                        zIndexOffset\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                backgroundStyle {\n                  ... on MapElementImageStyle {\n                    __isMapElementImageStyle: __typename\n                    iconClass\n                    color\n                    contrastColor\n                    width\n                    height\n                    anchor\n                    anchorOffsetX\n                    anchorOffsetY\n                    opacity\n                    image {\n                      __typename\n                      ... on Image {\n                        url\n                      }\n                      ... on StaticImage {\n                        url\n                      }\n                    }\n                  }\n                  id\n                }\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MapElementTooltip_tooltip on MapElementTooltip {\n  content\n}\n\nfragment MapElementsVectorGridTileLayerStyles_map on Map {\n  __isMap: __typename\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        __isMapElement: __typename\n        id\n        geometriesType\n        ... on MapElementCompoundFeature {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            shadowStyle {\n              offsetX\n              offsetY\n              blur\n              color\n              opacity\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPath {\n          style {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPoint {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPointStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementShape {\n          style {\n            zIndexOffset\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementShapeStyle {\n                  borderStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                    zoomLevels {\n                      zoomLevelMin\n                      zoomLevelMax\n                      style {\n                        __typename\n                        ... on MapElementPathStyle {\n                          color\n                          opacity\n                          style\n                          width\n                          zIndexOffset\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapElementsVectorGrid_map on Map {\n  __isMap: __typename\n  id\n  hasElements\n  vectorTileUrl\n  ...MapClusterizedPointMarkers_map\n  ...MapElementsVectorGridTileLayerStyles_map\n}\n\nfragment MapFilterElement_filter on MapFilterElement {\n  id\n  name\n  filterElementsOutOnInitialize\n  allowSelectingMultipleElements\n  mapElements {\n    __typename\n    id\n    name\n  }\n}\n\nfragment MapFilterList_filterList on MapFilterList {\n  filters {\n    __typename\n    id\n    ...MapFilter_filter\n  }\n}\n\nfragment MapFilterTaxonomyFilterWithChildren_mapTaxonomy on MapTaxonomy {\n  id\n  ...MapFilterTaxonomySelector_mapTaxonomy\n  children {\n    id\n    ...MapFilterTaxonomySelector_mapTaxonomy\n  }\n}\n\nfragment MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy on MapTaxonomy {\n  id\n  ...MapFilterTaxonomySelector_mapTaxonomy\n}\n\nfragment MapFilterTaxonomySelector_mapTaxonomy on MapTaxonomy {\n  id\n  name\n  iconUrl\n  children {\n    id\n  }\n}\n\nfragment MapFilterTaxonomy_filter on MapFilterTaxonomy {\n  id\n  allowSelectingMultipleTaxonomies\n  filterElementsOutOnInitialize\n  mapTaxonomies {\n    id\n    hasChildren\n    children {\n      id\n    }\n    ...MapFilterTaxonomyFilterWithChildren_mapTaxonomy\n    ...MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy\n  }\n}\n\nfragment MapFilterUserFieldSelect_userField on MapFilterUserField {\n  id\n  name\n  options {\n    id\n    name\n  }\n}\n\nfragment MapFilterUser_filter on MapFilterUser {\n  id\n  userFields {\n    id\n    ...MapFilterUserFieldSelect_userField\n  }\n}\n\nfragment MapFilter_filter on MapFilterBase {\n  __isMapFilterBase: __typename\n  __typename\n  ...MapFilterTaxonomy_filter\n  ...MapFilterElement_filter\n  ...MapFilterUser_filter\n}\n\nfragment MapFilters_map on Map {\n  __isMap: __typename\n  filterLists {\n    id\n    ...MapFilterList_filterList\n  }\n}\n\nfragment MapSidebarEventsList_eventsList on PageSectionSidebarEventsList {\n  id\n  title\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n}\n\nfragment MapSidebarTitle_map on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  allowSendingNotificationOnContentUpdate\n  taxonomies {\n    ...TaxonomyIcons_taxonomies\n    id\n  }\n  ...Breadcrumbs_page\n  ...Subscription_subscribable\n}\n\nfragment MapSidebar_map on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  ...MapSidebarTitle_map\n}\n\nfragment MapSidebar_sidebar on ResourceWithSections {\n  __isResourceWithSections: __typename\n  ...PageSections_page\n}\n\nfragment MapWithSidebarLayout_map on Map {\n  __isMap: __typename\n  ...MapBase_map\n}\n\nfragment PageSectionActorsList_pageSection on PageSectionActorsList {\n  title\n  iconClass\n  description\n  actorsPerRow\n  contentAlignment\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  actors {\n    id\n    name\n    description\n    logo {\n      ...ResponsiveImage_image\n      id\n    }\n  }\n}\n\nfragment PageSectionAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionBanner_pageSection on PageSectionBanner {\n  autoplay\n  slidesInterval\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  slides {\n    id\n    ...Slide_slide\n  }\n}\n\nfragment PageSectionCalendar_pageSection on PageSectionCalendar {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...Calendar_section\n}\n\nfragment PageSectionCookiesConsentsConfiguration_pageSection on PageSectionCookiesConsentsConfiguration {\n  title\n  iconClass\n  description\n  defaultAcceptsCookiesValue\n}\n\nfragment PageSectionEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  hlsUrl\n  code\n  url\n  format\n  isEmpty\n  mediaTitle\n  collapsible\n  collapsedHeight\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionEventsList_pageSection on PageSectionEventsList {\n  title\n  description\n  displayMode\n  hideIfEmpty\n  events {\n    id\n    ...EventCard_participativeModule\n  }\n}\n\nfragment PageSectionFeaturedContent_pageSection on PageSectionFeaturedContent {\n  title\n  iconClass\n  description\n  blocksDisplayMode\n  columnsRatio\n  columnsOrder\n  collapsible\n  collapsedHeight\n  featuredContentBlocks {\n    __typename\n    id\n  }\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  ...FeaturedContentGrid_featuredContent\n  ...FeaturedContentCarousel_featuredContent\n}\n\nfragment PageSectionFilesList_pageSection on PageSectionFilesList {\n  title\n  iconClass\n  description\n  columnsRatio\n  columnsOrder\n  sidebar {\n    hasSections\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  files {\n    id\n    ...LibraryFile_file\n  }\n}\n\nfragment PageSectionInformationSearch_pageSection on PageSectionInformationSearch {\n  id\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionMapElementFeatureAttribute_pageSection on PageSectionMapElementFeatureAttribute {\n  label\n  displayLabel\n  content\n}\n\nfragment PageSectionMap_pageSection on PageSectionMap {\n  title\n  description\n  mapHeight\n  zoomDefault\n  map {\n    __typename\n    ... on VisualizationMap {\n      participativeModule {\n        authorizations {\n          contributionsDisplayAuthorized\n        }\n        ...ContributionsMapContributionsMarkersManager_participativeModule\n        id\n      }\n    }\n    ...MapContextProvider_map\n    ...MapBase_map\n    id\n  }\n}\n\nfragment PageSectionPagesList_pageSection on PageSectionPagesList {\n  title\n  iconClass\n  description\n  resourceTargets {\n    id\n    name\n    url\n  }\n}\n\nfragment PageSectionParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  iconClass\n  description\n  displayQuestionsLabel\n  displayParticipationData\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  title\n  description\n  iconClass\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n}\n\nfragment PageSectionSearchBox_pageSection on PageSectionSearchBox {\n  title\n  iconClass\n  description\n  searchConfiguration {\n    id\n    displayOptionsByDefault\n  }\n}\n\nfragment PageSectionSidebarAnalyticsDataList_pageSection on PageSectionAnalyticsDataList {\n  title\n  description\n  analyticsData {\n    __typename\n    id\n    ...AnalyticsDatumCardRow_analyticsDatum\n  }\n}\n\nfragment PageSectionSidebarBanner_pageSection on PageSectionSidebarBanner {\n  fullHeight\n  autoplay\n  slidesInterval\n  slides {\n    id\n    ...Slide_slide\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarCalendar_pageSection on PageSectionCalendar {\n  title\n  description\n  ...Calendar_section\n}\n\nfragment PageSectionSidebarEmbed_pageSection on PageSectionEmbed {\n  title\n  iconClass\n  description\n  code\n  url\n  hlsUrl\n  format\n  mediaTitle\n  transcription {\n    url\n    id\n  }\n  audio {\n    url\n    ...AudioPlayer_audio\n    id\n  }\n  ...VideoPlayer_withVideoStream\n}\n\nfragment PageSectionSidebarEventsList_pageSection on PageSectionSidebarEventsList {\n  id\n  events {\n    id\n    ...SidebarEventCard_participativeModule\n  }\n  ...MapSidebarEventsList_eventsList\n}\n\nfragment PageSectionSidebarFilesList_pageSection on PageSectionFilesList {\n  files {\n    id\n    ...LibraryFile_file\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarLinkBlock_pageSection on PageSectionSidebarLinkBlock {\n  title\n  subtitle\n  iconClass\n  url\n}\n\nfragment PageSectionSidebarPagesList_pageSection on PageSectionPagesList {\n  resourceTargets {\n    id\n    name\n    url\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModuleResults_pageSection on PageSectionParticipativeModuleResults {\n  title\n  description\n  iconClass\n  displayQuestionsLabel\n  displayParticipationData\n  results {\n    __typename\n    id\n  }\n  ...ParticipativeModuleResultsFormFields_pageSection\n}\n\nfragment PageSectionSidebarParticipativeModulesList_pageSection on PageSectionParticipativeModulesList {\n  participativeModules {\n    id\n    ...ParticipativeModuleCard_participativeModule\n  }\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarText_pageSection on PageSectionSidebarText {\n  content\n  ...useSidebarSectionTitle_pageSection\n}\n\nfragment PageSectionSidebarUsersGroupRequestLinkBlock_pageSection on PageSectionSidebarUsersGroupRequestLinkBlock {\n  iconClass\n  addRequestTitle\n  removeRequestTitle\n  usersGroup {\n    id\n    name\n    alreadyGroupMember\n    alreadyRequested\n    authorizations {\n      sendJoinGroupRequest\n    }\n  }\n}\n\nfragment PageSectionSidebar_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionSidebarEmbed_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarPagesList_pageSection\n  ...PageSectionSidebarAnalyticsDataList_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n  ...PageSectionSidebarParticipativeModuleResults_pageSection\n  ...PageSectionSidebarParticipativeModulesList_pageSection\n  ...PageSectionSidebarCalendar_pageSection\n}\n\nfragment PageSectionSitemap_pageSection on PageSectionSitemap {\n  title\n  iconClass\n  description\n}\n\nfragment PageSectionText_pageSection on PageSectionText {\n  content\n  collapsible\n  collapsedHeight\n  columnsRatio\n  columnsOrder\n  sidebar {\n    ...ContainerWithSidebar_sidebar\n    id\n  }\n}\n\nfragment PageSection_pageSection on PageSectionBase {\n  __isPageSectionBase: __typename\n  __typename\n  ...PageSectionText_pageSection\n  ...PageSectionBanner_pageSection\n  ...PageSectionParticipativeModulesList_pageSection\n  ...PageSectionEventsList_pageSection\n  ...PageSectionCalendar_pageSection\n  ...PageSectionActorsList_pageSection\n  ...PageSectionPagesList_pageSection\n  ...PageSectionFilesList_pageSection\n  ...PageSectionFeaturedContent_pageSection\n  ...PageSectionSidebarText_pageSection\n  ...PageSectionSidebarLinkBlock_pageSection\n  ...PageSectionSidebarUsersGroupRequestLinkBlock_pageSection\n  ...PageSectionEmbed_pageSection\n  ...PageSectionParticipativeModuleResults_pageSection\n  ...PageSectionMap_pageSection\n  ...PageSectionSearchBox_pageSection\n  ...PageSectionAnalyticsDataList_pageSection\n  ...PageSectionSidebarFilesList_pageSection\n  ...PageSectionSidebarBanner_pageSection\n  ...PageSectionMapElementFeatureAttribute_pageSection\n  ...PageSectionCookiesConsentsConfiguration_pageSection\n  ...PageSectionSitemap_pageSection\n  ...PageSectionInformationSearch_pageSection\n  ...PageSectionSidebarEventsList_pageSection\n}\n\nfragment PageSections_page on ResourceWithSections {\n  __isResourceWithSections: __typename\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        ...PageSection_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ParticipativeModuleCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  thumbUrl\n  visualization {\n    __typename\n    iconClass\n    id\n  }\n  currentStep {\n    ...CardStep_step\n    id\n  }\n  ...ParticipativeModuleMeasures_participativeModule\n}\n\nfragment ParticipativeModuleLayout_participativeModule on ParticipativeModule {\n  id\n  slug\n  title\n  displayParticipativeModuleStepsAfterSections\n  message\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n  visualization {\n    __typename\n    isFullScreen\n    id\n  }\n  ...ContributeButton_participativeModule\n  ...Steps_steppable\n  ...PageSections_page\n  ...TitleBarWithAction_resource\n  ...Breadcrumbs_page\n}\n\nfragment ParticipativeModuleMeasures_participativeModule on ParticipativeModule {\n  authorizations {\n    votesDisplayAuthorized\n    votesDownAuthorized\n    contributionsCountDisplayAuthorized\n  }\n  votesUpCount\n  votesDownCount\n  contributionsCount\n}\n\nfragment ParticipativeModuleResultsFormFields_pageSection on PageSectionParticipativeModuleResults {\n  id\n  participativeModuleIds\n}\n\nfragment ParticipativeModuleVisualization_participativeModule on ParticipativeModule {\n  id\n  visualization {\n    __typename\n    ...ContributionsDataviz_visualization\n    ...ContributionsMap_map\n    ...CityWalk_cityWalk\n    id\n  }\n}\n\nfragment ParticipativeModule_participativeModule on ParticipativeModuleInterface {\n  __isParticipativeModuleInterface: __typename\n  __typename\n  ... on ParticipativeModule {\n    authorizations {\n      visualizationDisplayAuthorized\n    }\n    ...ParticipativeModuleLayout_participativeModule\n    ...ParticipativeModuleVisualization_participativeModule\n  }\n  ... on Event {\n    ...Event_participativeModule\n  }\n}\n\nfragment ResponsiveImage_image on ResponsiveImage {\n  altText\n  large {\n    ratio\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  medium {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n  small {\n    url\n    x15Url\n    x2Url\n    width\n    height\n  }\n}\n\nfragment SidebarEventCard_participativeModule on ParticipativeModule {\n  slug\n  title\n  visualization {\n    __typename\n    ... on EventVisualization {\n      startsAt\n    }\n    id\n  }\n}\n\nfragment Sidebar_sidebar on Sidebar {\n  sections(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        domId\n        fullHeight\n        ...PageSectionSidebar_pageSection\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SlideCaption_slide on Slide {\n  caption\n}\n\nfragment SlideContainer_slide on Slide {\n  url\n  enableOverlay\n  ...LinkSlide_slide\n}\n\nfragment SlideOverlay_slide on Slide {\n  url\n  enableOverlay\n  overlayContent\n  overlayButtonText\n  overlayContentPosition\n  overlayContentTextColor\n  overlayButtonBackgroundColor\n  overlayButtonTextColor\n  overlayBackgroundColor\n  overlayOpacity\n}\n\nfragment Slide_slide on Slide {\n  ...SlideContainer_slide\n  ...SlideCaption_slide\n  ...SlideOverlay_slide\n  image {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment StepDetails_step on Step {\n  id\n  name\n  position\n  isCurrent\n  startDate\n  endDate\n}\n\nfragment Steps_steppable on Steppable {\n  __isSteppable: __typename\n  displayParticipativeModuleSteps\n  steps {\n    id\n    isCurrent\n    ...StepDetails_step\n  }\n}\n\nfragment SubscribeToEventButton_participativeModule on Event {\n  slug\n  authorizations {\n    contributionsSubmissionAuthorized\n  }\n  visualization {\n    __typename\n    customIntlMessages {\n      identifier\n      message\n      id\n    }\n    id\n  }\n}\n\nfragment SubscriptionModal_subscribable on ResourceWithSubscription {\n  __isResourceWithSubscription: __typename\n  id\n}\n\nfragment Subscription_subscribable on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  id\n  allowSendingNotificationOnContentUpdate\n  alreadySubscribed\n  subscribersCount\n  ...SubscriptionModal_subscribable\n}\n\nfragment TaxonomyIcons_taxonomies on ResourceTreeTaxonomy {\n  taxonomy {\n    id\n    name\n    titleImageUrl\n  }\n}\n\nfragment TitleBarWithAction_resource on ResourceTreeLeaf {\n  __isResourceTreeLeaf: __typename\n  title\n  ancestors {\n    __typename\n    resourcePath\n    id\n  }\n  taxonomies {\n    ...TaxonomyIcons_taxonomies\n    id\n  }\n  ... on ResourceWithSubscription {\n    __isResourceWithSubscription: __typename\n    ...Subscription_subscribable\n  }\n  ...Breadcrumbs_page\n}\n\nfragment VideoPlayer_withVideoStream on WithBunnyStreamVideo {\n  __isWithBunnyStreamVideo: __typename\n  hlsUrl\n  hlsLibUrl\n  width\n  height\n  cover {\n    ...ResponsiveImage_image\n    id\n  }\n}\n\nfragment useMapElementsFilteredIn_map on Map {\n  __isMap: __typename\n  id\n  filterLists {\n    filters {\n      __typename\n      id\n      ... on MapFilterTaxonomy {\n        filterElementsOutOnInitialize\n        mapTaxonomies {\n          id\n          children {\n            id\n          }\n        }\n      }\n      ... on MapFilterElement {\n        filterElementsOutOnInitialize\n        mapElements {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        mapTaxonomies {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useSidebarSectionTitle_pageSection on PageSectionWithHeadingData {\n  __isPageSectionWithHeadingData: __typename\n  title\n  iconClass\n}\n"
  }
};
})();

node.hash = "3c566bd139cbef338512b1f99de06e0e";

module.exports = node;
